import React, {useEffect, useState} from "react";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import MDBox from "../../components/MDBox";
import Grid from "@mui/material/Grid";
import Footer from "../../examples/Footer";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import MDButton from "../../components/MDButton";
import {
    FormControl,
    IconButton, InputLabel,
    Menu,
    MenuItem, Select, TextField
} from "@mui/material";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import {useNavigate, useParams} from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import {getFields} from "../dialog/formfields";
import PropTypes from "prop-types";
import DataTableConfig from "../Tables/DataTableConfig";
import tableData from "../tabledata";
import useConfigApi from "../utils/configapi";
import Endpoints from "../utils/endpoints";
import toast from "react-hot-toast";
import MDTypography from "../../components/MDTypography";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";


let groupConfigs = [];

const ConfigInfoBox = ({ selectedValues }) => {
    const selectedConfig = groupConfigs.find(grp => grp.grpId === selectedValues?.grpId);
    if (!selectedConfig) return null;

    return (
        <MDBox sx={{
            padding: '16px',
            borderRadius: '12px',
            border: '1px solid #e0e0e0',
            backgroundColor: '#fff',
            width:"80%",
            fontSize: '14px',
            lineHeight: '1.6',
        }}>
            <div><label>Control name Config: </label> <label style={{color:"#3C96EF"}}>{selectedConfig.grpConfigName}</label></div>
            <div><label>Ctrl Type: </label> <label style={{color:"#3C96EF"}}>{selectedConfig.grpType}</label></div>
            <div><label>Control ID: </label> <label style={{color:"#3C96EF"}}>{selectedConfig.grpId}</label></div>
        </MDBox>
    );
};

ConfigInfoBox.propTypes = {
    selectedValues: PropTypes.shape({
        grpId: PropTypes.string,
    }),
};
function DeviceConfig() {

    const { deviceConfigColumns } = tableData();
    const { deviceConfigFields } = getFields();
    const [deviceConfig, setDeviceConfig] = useState([]);
    const [anchorEl, setAnchorEl] = useState(null);
    const [activeRow, setActiveRow] = useState(null);
    const [isModalOpen, setModalOpen] = useState(false);
    const { groupId } = useParams();
    const [dialogData, setDialogData] = React.useState(null);
    const [dialogMode, setDialogMode] = React.useState("create");
    const [dialogTitle, setDialogTitle] = React.useState("Create DeviceConfig");
    const [deviceConfigFieldsModified, setDeviceConfigFieldsModified] = useState([]);
    const api = useConfigApi();
    const navigate = useNavigate();
    const [clearConfig, setClearConfig] = useState(false);
    const [serialOptions, setSerialOptions] = useState([]);
    const [unmappedDevices, setUnmappedDevices] = useState([]);
    const [bulkFile, setBulkFile] = useState(null);
    const fileInputRef = React.useRef();





    const handleMenuOpen = (event, row) => {
        setAnchorEl(event.currentTarget);
        setActiveRow(row);
    };
    const openModal = () => {
        setDialogMode("create");
        setModalOpen(true);
        setDialogTitle("Create DeviceConfig");
        if(groupId) {
            setDialogData({grpId: groupId}); // pre-fill the field});
        } else {
            setDialogData({});
        }
        updateDeviceConfigFields('create', groupId);

    };

    const closeModal = () => {
        setModalOpen(false);
        setDialogData(null);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
        setActiveRow(null);
    };

    const handleActionClick = (action: string, item) => {
        if(action === 'View'){
            setModalOpen(true);
            setDialogMode("view");
            setDialogTitle("View DeviceConfig");
            fetchControlConfigByDevice(activeRow, "viewDevice");
        } else if (action === 'Edit') {
            setModalOpen(true);
            setDialogMode("edit");
            setDialogTitle("Edit DeviceConfig");
            fetchControlConfigByDevice(activeRow, "editDevice");

        }  else if(action === 'editParam') {
            console.log(`${item.slNo}`);
            fetchControlConfigByDevice(item, "editParam");

        } else if (action === 'Delete') {
            setModalOpen(true);
            setDialogMode("delete");
            setDialogTitle("Delete DeviceConfig");
            setDialogData(activeRow);
        }  else if (action === 'permanentDelete') {
            setModalOpen(true);
            setDialogMode("delete");
            setDialogTitle("Delete DeviceConfig");
            setDialogData(activeRow);
        }

        handleMenuClose();
    };

    const handleDialogSubmit = (formData) => {
        console.log("Submitted data:", formData, dialogMode);
        // Call your API here
        if (dialogMode === "create") {
            // Handle create logic here
            if(groupId) {
                api.put(Endpoints.devices.createOrUpdate, formData)
                    .then((response) => {
                        toast.success("Device config successfully updated.");
                        setModalOpen(false);
                        fetchDevicesConfig().catch(console.error); // Fetch the latest data after editing
                    })
                    .catch((error) => {
                        const responseMessage = error?.response?.data?.responseMessage;
                        if (responseMessage.includes("duplicate key value") &&
                            responseMessage.includes("serial_number")) {
                            toast.error("Serial number already exists.");
                        } else {
                            toast.error("Internal error occurred while creating.");
                        }

                    });
            } else {
                api.post(Endpoints.devices.createOrUpdate, formData)
                    .then((response) => {
                        toast.success("Device config successfully created.");
                        setModalOpen(false);
                        fetchDevicesConfig().catch(console.error); // Fetch the latest data after creation
                    })
                    .catch((error) => {
                        const responseMessage = error?.response?.data?.responseMessage;
                        if (responseMessage.includes("duplicate key value") &&
                            responseMessage.includes("serial_number")) {
                            toast.error("Serial number already exists.");
                        } else {
                            toast.error("Internal error occurred while updating.");
                        }

                    });
            }

        } else if (dialogMode === "edit") {
            api.put(Endpoints.devices.createOrUpdate, formData)
                .then((response) => {
                    toast.success("Device config successfully updated.");
                    setModalOpen(false);
                    fetchDevicesConfig().catch(console.error); // Fetch the latest data after editing
                })
                .catch((error) => {
                    toast.error("Internal error occurred while updating.");
                });
        }
    };

    const handleDialogDelete = (formData) => {
        if (!formData.terminalId) {
            toast.error("Missing Terminal ID for deletion.");
            return;
        }
        api.delete(Endpoints.devices.deleteById(formData.slNo))
            .then(() => {
                toast.success("Device config successfully deleted.");
                fetchDevicesConfig().catch(console.error);
            })
            .catch(() => {
                toast.error("Error deleting device config.");
            });
    };

    useEffect(() => {
        fetchDevicesConfig().catch(console.error);
     },[groupId]);

    const fetchControlConfigByDevice = async (deviceData, route) => {
        try {
            const apiResponse = await api.get(Endpoints.devices.getByTerminalId(deviceData.slNo));
            const fullResponse = apiResponse?.data?.data || {};
            const item = fullResponse?.controlConfig;
            const devices = fullResponse?.deviceConfig;
            if(route === 'editDevice') {
                // const dataToSet = {
                //     ...devices,
                //     grpId: item ? devices?.groupConfig?.grpConfigName: devices?.groupConfig?.grpId,
                //     controlConfigSerialNumber: item?.controlName
                // };
                const dataToSet = {
                    ...devices,
                    grpId: devices?.groupConfig?.grpId,
                    controlConfigSerialNumber: item?.slNo,
                    grpIdText: devices?.groupConfig?.grpConfigName,
                    controlSerialNumberText: item?.controlName?.split('_')[0] ?? '',
                    serialNumber: devices?.serialNumber
                };
                console.log('dataToSet', dataToSet);
                setDialogData(dataToSet);
                updateDeviceConfigFields('edit', groupId, dataToSet);
            } else if(route === 'viewDevice') {
                // const dataToSet = {
                //     ...devices,
                //     grpId: item ? devices?.groupConfig?.grpConfigName: devices?.groupConfig?.grpId,
                //     controlConfigSerialNumber: item?.controlName
                // };
                const dataToSet = {
                    ...devices,
                    grpId: devices?.groupConfig?.grpId,
                    controlConfigSerialNumber: item?.slNo,
                    grpIdText: devices?.groupConfig?.grpConfigName,
                    controlSerialNumberText: item?.controlName?.split('_')[0] ?? '',
                    serialNumber: devices?.serialNumber
                };
                console.log('dataToSet', dataToSet);
                setDialogData(dataToSet);
                updateDeviceConfigFields('view', groupId, dataToSet);
            } else {
                if(item === null) {
                    toast.error("No configuration mapped with device.");
                } else {
                    navigate(`/control-config-view/`, {
                        state: { item },
                    });
                }

            }


        } catch (e) {
            console.log(e);
        }

    }

    const fetchDevicesConfig = async () => {
        try {
            // 1. Fetch Devices
            const devicesResponse = await api.get(groupId
                ? Endpoints.devices.getByGroupId(groupId)
                : Endpoints.devices.getAll(false));
            const devices = devicesResponse?.data?.data || [];

            // 2. Fetch Groups
            const groupsResponse = await api.get(Endpoints.groups.getAll(false));
            const groups = groupsResponse?.data?.data || [];
            groupConfigs = groups;

            if (groupId) {
                const snResponse = await api.get(Endpoints.devices.fetchUnmapDevice());
                const unmapDevices = snResponse?.data?.data || [];
                const options = unmapDevices.map((unmapDevice) => ({
                    label: unmapDevice.serialNumber,
                    value: unmapDevice.serialNumber,
                }));
                setUnmappedDevices(unmapDevices);
                setSerialOptions(options);
            } else {
                setSerialOptions([]);
                setUnmappedDevices([]);
            }

            // 3. Format Table Data
            const modifiedDevices = devices.map((item) => {
                const action = (
                    <>
                        <MDTypography
                            display="inline"
                            color="info"
                            sx={{
                                borderBottom: "1px solid #2196F3",
                                paddingBottom: "1px",
                                fontSize: "14px",
                                textTransform: "capitalize",
                                fontWeight: "light",
                                cursor: "pointer",
                                marginRight: 1,
                            }}
                            onClick={() => handleActionClick("editParam", item)}
                        >
                            Edit Parameters
                        </MDTypography>
                        <IconButton onClick={(e) => handleMenuOpen(e, item)}>
                            <MoreHorizIcon />
                        </IconButton>
                    </>

                );
                return { ...item, action };
            });

            setDeviceConfig(modifiedDevices);

            // 4. Prepare Options for Select Field
            // const groupOptions = groups.map((group) => ({
            //     label: group.grpConfigName,  // adjust if needed
            //     value: group.grpId
            // }));
            //
            // setDeviceConfigFieldsModified(deviceConfigFields.map(field =>
            //     field.name === "grpId"
            //         ? { ...field, options: groupOptions, readonly: !!groupId }
            //         : field
            // ));
            updateDeviceConfigFields(dialogMode, groupId);

        } catch (error) {
            toast.error("Error while fetching devices or group data.");
            console.error(error);
        }
    };

    const updateDeviceConfigFields = (mode, grpId, dialogdata) => {
        const groupOptions = groupConfigs.map((group) => ({
            label: group.grpConfigName,
            value: group.grpId
        }));

        if(dialogdata?.controlConfigSerialNumber && mode === 'edit') {
            setClearConfig(true);
        } else {
            setClearConfig(false);
        }
        const showTextFields = !!dialogdata?.grpId && !!dialogdata?.controlConfigSerialNumber;

        const updatedFields = deviceConfigFields.map(field => {
            if (field.name === "grpId") {
                return {
                    ...field,
                    options: groupOptions,
                    hidden: showTextFields,
                    readonly: !!groupId
                };
            }
            // if (field.name === "grpIdText") {
            //     return {
            //         ...field,
            //         hidden: (!!dialogdata?.grpId && !!dialogdata?.controlConfigSerialNumber) || (groupId && mode !== 'clearconfig')
            //     };
            // }
            if (field.name === "grpIdText") {
                return {
                    ...field,
                    hidden: !showTextFields
                };
            }
            if (field.name === "controlSerialNumberText") {
                return {
                    ...field,
                    options: groupOptions,
                    hidden: !showTextFields,
                };
            }
            if (field.name === "controlConfigSerialNumber") {
                return {
                    ...field,
                    hidden: showTextFields,
                };

            }
            if (field.name === "serialNumber") {
                return {
                    ...field,
                    type: grpId && mode === 'create' ? "select" : "text",
                    options: serialOptions,
                    readonly: mode === "view",
                };
            }
            return field;
        });

        setDeviceConfigFieldsModified(updatedFields);
    };

    useEffect(() => {
        if (dialogData?.grpId) {
            fetchControlConfigsByGroup(dialogData.grpId);
        }
    }, [dialogData?.grpId]);

    const fetchControlConfigsByGroup = async (grpId) => {
        try {
            const response = await api.get(Endpoints.controlConfig.getByGrpId(grpId));
            const controlConfigs = response?.data?.data || [];
            const controlConfigOptions = controlConfigs.map(config => ({
                label: config.controlName,
                value: config.slNo
            }));
            const updatedFields = deviceConfigFieldsModified.map((field) => {
                if (field.name === "controlConfigSerialNumber") {
                    return { ...field, options: controlConfigOptions };
                }
                return field;
            });

            console.log('updated fields', updatedFields);
            setDeviceConfigFieldsModified(updatedFields);
            if (controlConfigOptions.length > 0 && (groupId && dialogMode === 'edit')) {
                setDialogData((prev) => ({
                    ...prev,
                    controlConfigSerialNumber: controlConfigOptions[0].value,
                }));
            }

        } catch (e) {
           // console.log('updated fields', updatedFields);
            console.log(e)
           // toast.error("Failed to fetch serial number.");
        }
    };

    const handleClearConfig = async (formData) => {
        try {
            try {
                const response = await api.delete(Endpoints.devices.unmapControlConfig(formData.slNo));
                toast.success("Device Configuration cleared!")
                // Only clear values for grpId and controlConfigSerialNumber
                setDialogData((prev) => ({
                    ...prev,
                    grpId: null,
                    controlConfigSerialNumber: null,
                }));

                updateDeviceConfigFields('clearconfig');

            } catch (e) {
                console.log(e)
                // toast.error("Failed to fetch serial number.");
            }


            // Make those fields editable
            // const updatedFields = deviceConfigFieldsModified.map((field) => {
            //     if (field.name === "grpId" || field.name === "controlConfigSerialNumber") {
            //         return { ...field, type: 'select', readonly: false };
            //     }
            //     return field;
            // });
            //
            // setDeviceConfigFieldsModified(updatedFields);

            //   toast.success("Config cleared successfully.");
        } catch (error) {
            console.error("Failed to clear config", error);
           // toast.error("Failed to clear config.");
        }
    };
    const bulkUpload = () => {
        fileInputRef.current.click(); // Opens file picker
    };

    const uploadFile = async (file) => {
        const formData = new FormData();
        formData.append("file", file);

        try {
            const response = await api.post(Endpoints.devices.bulkUpload, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });
            toast.success("File uploaded successfully!");
            fetchDevicesConfig().catch(console.error);;
            // optionally refresh table data here
        } catch (error) {
            toast.error("File upload failed.");
        }
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        const isExcel = file.name.endsWith(".xls") || file.name.endsWith(".xlsx");
        if (!isExcel) {
            alert("Only .xls or .xlsx files are allowed.");
            return;
        }
        setBulkFile(file);
        uploadFile(file); // Trigger upload immediately or show confirm dialog
    };

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox mt={6} mb={3}>
                <Grid container spacing={3} justifyContent="center">
                    <Grid container justifyContent="flex-end">
                        {/*<MDButton variant="gradient" color="info"*/}
                        {/*          onClick={bulkUpload} style={{marginRight: "24px", marginBottom: "12px"}}>*/}
                        {/*    Bulk Upload here*/}
                        {/*</MDButton>*/}
                        <input
                            type="file"
                            ref={fileInputRef}
                            style={{ display: "none" }}
                            accept=".xls,.xlsx"
                            onChange={handleFileChange}
                        />
                        {!groupId && (
                            <MDButton
                                variant="gradient"
                                color="info"
                                onClick={bulkUpload}
                                sx={{ mr: 3, mb: 1.5 }}
                            >
                                Bulk Upload here
                            </MDButton>
                        )}
                        <MDButton
                            variant="gradient"
                            onClick={openModal}
                            color="info"
                            sx={{ mr: 3, mb: 1.5 }}
                        >
                            Add Device
                        </MDButton>
                    </Grid>
                    <Grid item xs={12} lg={12}>
                        <DataTableConfig
                            table={{ columns : deviceConfigColumns, rows : deviceConfig }}
                            showTotalEntries={true}
                            isSorted={true}
                            noEndBorder
                            entriesPerPage={true}
                            canSearch={true}
                        />
                    </Grid>
                </Grid>
            </MDBox>
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
                onClick={handleMenuClose}
            >
                <MenuItem onClick={() => handleActionClick("View")}>
                    <IconButton size="small">
                        <i className="material-icons">visibility</i>
                    </IconButton>
                    View
                </MenuItem>
                <MenuItem onClick={() => handleActionClick("Edit")}>
                    <IconButton size="small">
                        <EditIcon fontSize="small" />
                    </IconButton>
                    Edit
                </MenuItem>
                {/*<MenuItem onClick={() => handleActionClick("Delete")}>*/}
                {/*    <IconButton size="small" color="error">*/}
                {/*        <DeleteIcon fontSize="small" />*/}
                {/*    </IconButton>*/}
                {/*    Delete*/}
                {/*</MenuItem>*/}
                {/*<MenuItem onClick={() => handleActionClick("permanentDelete")}>*/}
                {/*    <IconButton size="small" color="error">*/}
                {/*        <DeleteIcon fontSize="small" />*/}
                {/*    </IconButton>*/}
                {/*    Permanent Delete*/}
                {/*</MenuItem>*/}
            </Menu>
            {/*<GenericForm*/}
            {/*    open={isModalOpen}*/}
            {/*    handleClose={closeModal}*/}
            {/*    title={dialogTitle}*/}
            {/*    fields={deviceConfigFieldsModified}*/}
            {/*    onSubmit={handleDialogSubmit}*/}
            {/*    onDelete={handleDialogDelete}*/}
            {/*    initialData={dialogData}*/}
            {/*    mode={dialogMode}*/}
            {/*    useDialog={true}*/}
            {/*    maxWidth="sm"*/}
            {/*    CustomComponent={ConfigInfoBox}*/}
            {/*/>*/}
            <Dialog open={isModalOpen} onClose={closeModal} maxWidth="sm" fullWidth>
                <DialogTitle>{dialogTitle}</DialogTitle>
                <DialogContent dividers>
                    {dialogMode !== "delete" ? (
                        <>
                            <Grid container spacing={2} mt={1}>
                                {deviceConfigFieldsModified.map((field) =>{
                                    if (field.hidden || dialogMode === "create" && field.name === "slNo") return null;
                                    return (

                                        <Grid item xs={field.xs || 12} key={field.name}>
                                            {field.type === "select" ? (
                                                <FormControl
                                                    fullWidth
                                                    disabled={field.readonly || dialogMode === "view"}
                                                >
                                                    <InputLabel>{field.label}</InputLabel>
                                                    <Select
                                                        value={dialogData?.[field.name] || ""}
                                                        label={field.label}
                                                        onChange={(e) => {
                                                            const chosenSn = e.target.value;
                                                            setDialogData((prev) => ({
                                                                ...prev,
                                                                [field.name]: chosenSn,
                                                            }));

                                                            if (field.name === "serialNumber") {
                                                                const found = unmappedDevices.find(
                                                                    (d) => d.serialNumber === chosenSn
                                                                );
                                                                if (found) {
                                                                    setDialogData((prev) => ({
                                                                        ...prev,
                                                                        terminalName: found.terminalName,
                                                                        terminalBrand: found.terminalBrand,
                                                                        deviceStatus: found.deviceStatus,
                                                                        serialNumber: chosenSn,
                                                                        slNo: found.slNo
                                                                    }));
                                                                } else {
                                                                    // fallback if not found:
                                                                    setDialogData((prev) => ({
                                                                        ...prev,
                                                                        terminalName: "",
                                                                        terminalBrand: "",
                                                                        deviceStatus: "",
                                                                        serialNumber: chosenSn,
                                                                    }));
                                                                }
                                                            }
                                                        }}
                                                        IconComponent={() => (
                                                            <ArrowDropDownIcon sx={{ color: 'black', fontSize: "25px !important" }} />
                                                        )}
                                                        sx={{
                                                            height: "45px",
                                                            '& .MuiSelect-select': {
                                                                paddingTop: '14px',
                                                                paddingBottom: '14px',
                                                                display: 'block',
                                                                overflow: 'hidden',
                                                                whiteSpace: 'nowrap',
                                                                textOverflow: 'ellipsis',
                                                            },
                                                        }}
                                                    >
                                                        {field.options?.map((opt) => (
                                                            <MenuItem key={opt.value} value={opt.value}>
                                                                {opt.label}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            ) : (
                                                <TextField
                                                    label={field.label}
                                                    fullWidth
                                                    value={dialogData?.[field.name] || ""}
                                                    onChange={(e) =>
                                                        setDialogData((prev) => ({
                                                            ...prev,
                                                            [field.name]: e.target.value,
                                                        }))
                                                    }
                                                    disabled={field.readonly || dialogMode === "view"}
                                                />
                                            )}
                                        </Grid>
                                    )
                                })}
                            </Grid>
                            <MDBox sx={{ mt: 3 }}>
                            <ConfigInfoBox selectedValues={dialogData} />
                            </MDBox>
                        </>
                    ) : (
                        <MDBox sx={{ p: 3 }}>
                            <MDTypography fontSize="1rem">
                                Are you sure you want to delete this device config?
                            </MDTypography>
                        </MDBox>
                    )}
                </DialogContent>
                <DialogActions>
                    {clearConfig && (
                            <MDButton onClick={() => handleClearConfig(dialogData)} color="warning">
                                Clear Config
                            </MDButton>
                        )}
                    {dialogMode !== "view" && dialogMode !== "delete" && (
                        <MDButton onClick={() => handleDialogSubmit(dialogData)} color="info">
                            Save
                        </MDButton>
                    )}
                    <MDButton onClick={closeModal} color="light">
                        Cancel
                    </MDButton>
                    {dialogMode === "delete" && (
                        <MDButton
                            onClick={() => {
                                handleDialogDelete(dialogData);
                                closeModal();}}
                            color="error"
                        >
                            Yes
                        </MDButton>
                    )}
                </DialogActions>
            </Dialog>
            <Footer />
        </DashboardLayout>
    );
}

export default DeviceConfig;

